import { render, staticRenderFns } from "./CyberbladeApp.vue?vue&type=template&id=b8f65690&scoped=true"
import script from "./CyberbladeApp.vue?vue&type=script&lang=ts"
export * from "./CyberbladeApp.vue?vue&type=script&lang=ts"
import style0 from "./CyberbladeApp.vue?vue&type=style&index=0&id=b8f65690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f65690",
  null
  
)

export default component.exports